

/*
 * Searches for an input field of type text and initializes it as Google Place Autocomplete element
 * Requires a reference to the Google Maps Javascript link with the API key and the Places API reference...
 * 
 * <script type="text/javascript" src="https://maps.googleapis.com/maps/api/js?key=YOUR_API_KEY&libraries=places"></script>
 * 
 * This function uses the following data attibutes
 * - geo-address=search: this is the autocomplete input field
 * - geo-address=toggle: a container element that will become visible when an address has been selected in the
 * autocomplete element. You should initialize this field with the "hidden" class
 * - geo-address=unit: input field that will be set with the unit number part of the address
 * - geo-address=street_number: input field that will be set with the street number part of the address
 * - geo-address=route: input field that will be set with the full street name part of the address
 * - geo-address=locality: input field that will be set with the suburb (or city) part of the address
 * - geo-address=state: input field that will be set with the state part of the address
 * - geo-address=country: input field that will be set with the country part of the address
 * - geo-address=postcode: input field that will be set with the postcode part of the address
 */

$(function () {

    $("input[type=text][geo-address=search]").each(function (idx, element) {

        var autocomplete = new google.maps.places.Autocomplete(element);
        autocomplete.addListener("place_changed", function () {
            //clear all fields
            $("[geo-address=unit],[geo-address=street_number],[geo-address=route],[geo-address=locality],[geo-address=state],[geo-address=country],[geo-address=postcode]").val(null);
            var place = autocomplete.getPlace();

            if (place && place.address_components && place.address_components.length > 0) {

                var components = place.address_components;

                for (var i = 0; i < components.length; i++) {
                    if (components[i].types && components[i].types.length > 0) {

                        var types = components[i].types;

                        for (var j = 0; j < types.length; j++) {
                            if (types[j] == "subpremise") {
                                $("[geo-address=unit]").val(components[i].long_name).trigger("change");
                            }
                            else if (types[j] == "street_number") {
                                $("[geo-address=street_number]").val(components[i].long_name).trigger("change");
                            }
                            else if (types[j] == "route") {
                                $("[geo-address=route]").val(components[i].long_name).trigger("change");
                            }
                            else if (types[j] == "locality") {
                                $("[geo-address=locality]").val(components[i].long_name).trigger("change");
                            }
                            else if (types[j] == "administrative_area_level_1") {
                                $("[geo-address=state]").val(components[i].long_name).trigger("change");
                            }
                            else if (types[j] == "country") {
                                $("[geo-address=country]").val(components[i].long_name).trigger("change");
                            }
                            else if (types[j] == "postal_code") {
                                $("[geo-address=postcode]").val(components[i].long_name).trigger("change");
                            }
                        }

                        $("[geo-address=toggle]").removeClass("hidden").show();
                    }
                }
            }
        });

    });
});